/** Matches the most genres a profile can save. */
export const GENRE_COLOR_COUNT = 30

export interface GenreColor {
    wash: string
    ink: string
}

/**
 * 30 hues spaced 12 degrees apart, then shuffled so neighboring genres
 * land far apart on the wheel. Ink stays dark enough to read on white.
 */
export function genreColor(index: number): GenreColor {
    const slot = ((index % GENRE_COLOR_COUNT) + GENRE_COLOR_COUNT) % GENRE_COLOR_COUNT
    const hue = (slot * 84) % 360
    return {
        wash: `hsl(${hue} 68% 88%)`,
        ink: `hsl(${hue} 62% 28%)`,
    }
}

export function genreColorMap(genres: string[]) {
    const colors = new Map<string, GenreColor>()
    genres.forEach((genre, index) => {
        const key = genre.trim().toLowerCase()
        if (!key || colors.has(key)) return
        colors.set(key, genreColor(index))
    })
    return colors
}
